import React, { useEffect } from "react";
import Counter from "./Counter";
import Calculator from "./Calculator";
import TimeOut from "./TimeOut";
import CountdownTimer from "./CountdownTimer";
import TimerLeft from "./TimerLeft";

export const launchingRef = React.createRef();

const PracticeHome = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Counter />
      <Calculator />
      <TimeOut />
      <CountdownTimer />
      <TimerLeft />
    </>
  );
};

export default PracticeHome;
